import { twMerge } from 'tailwind-merge';

import CourseTrackCard from '@/components/student-dashboard/CourseTrackCard';
import { COURSE_TRACK_ITEM_CLASS_NAME } from '@/components/student-dashboard/CourseTrackSkeleton';
import SeeAllUnitsCard from '@/components/student-dashboard/SeeAllUnitsCard';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { InfinitePaginationProps } from '@/components/ui/custom/InfinityList';
import { Carousel, Loading } from '@/components/ui/daisy';
import { CourseTrackLessonWithHref } from '@/data/hook/student-dashboard/useStudentCourseTrack';
import useInfiniteScroll from '@/data/hook/useInfiniteScroll';

type CourseTrackListProps = InfinitePaginationProps & {
  lessons: CourseTrackLessonWithHref[];
  unitsHref: string;
  className?: string;
};

export default function CourseTrackList({
  lessons,
  unitsHref,
  hasNextPage,
  onReachEnd,
  className,
}: CourseTrackListProps) {
  const { endSentinelRef, scrollContainerRef } = useInfiniteScroll({
    onReachEnd,
    hasNextPage,
    scroll: true,
  });

  return (
    <Carousel
      ref={scrollContainerRef}
      className={twMerge('flex w-full gap-6', className)}
    >
      {lessons.map(({ href, ...lesson }) => (
        <Carousel.Item
          key={lesson.lessonId}
          className={COURSE_TRACK_ITEM_CLASS_NAME}
        >
          <CourseTrackCard lesson={lesson} href={href} />
        </Carousel.Item>
      ))}
      <ConditionalRenderer condition={!!hasNextPage}>
        <Carousel.Item
          ref={endSentinelRef}
          role="presentation"
          className="w-16 shrink-0 items-center justify-center"
        >
          <Loading size="lg" color="primary" />
        </Carousel.Item>
      </ConditionalRenderer>
      <Carousel.Item className="w-72 md:hidden">
        <SeeAllUnitsCard href={unitsHref} />
      </Carousel.Item>
    </Carousel>
  );
}
